module.exports = __webpack_public_path__ + "img/campolivre-galeria-foto01.b0686e50.jpg";